import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import DontLeave from "app/pages/.shared/DontLeave";
import Page from "app/pages/.shared/Page/Page";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { sendTagOnPageNotFound } from "app/utils/analytics";
import { getFallbackRedirectUrl } from "app/reducers/partnerSelector";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./NotFound.scss";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const NotFound = ({ fallbackRedirectUrl }) => {
	useEffect(() => {
		sendTagOnPageNotFound();
	}, []);

	return (
		<div className="not-found">
			<Page title={<FormattedMessage id="not.found.title" />}>
				<HeadMetadata description="page.description.404" title="page.title.404" />
				<div className="not-found__intro">
					<FormattedMessage id="not.found.message" />
					<DontLeave>
						<Button
							to={{ pathname: fallbackRedirectUrl }}
							variant={BUTTON_VARIANTS.FILLED}
							size={BUTTON_SIZES.LARGE}
							label={<FormattedMessage id="confirmation.leave.button.label" />}
							data-testid="confirm-leave-link"
						/>
					</DontLeave>
				</div>
			</Page>
		</div>
	);
};

NotFound.propTypes = {
	fallbackRedirectUrl: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
	};
};

export default connect(mapStateToProps)(NotFound);
